import React from "react";
import { Box } from "@mui/material";
import { PickupLocationManagementCard } from "./PickupLocationManagementCard";

export const PickupLocationManagementSettings: React.FC = () => {
    return (
        <Box data-testid="pickup-location-management-settings-card">
            <PickupLocationManagementCard />
        </Box>
    );
};
